"use client";

import { Box, IconButton, Typography, alpha } from "@mui/material";
import { ReferEarnSlide } from "./ReferEarnSlide";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import "./ReferEarn.css";
import { useEffect, useState } from "react";
import WalletBalance from "./WalletBalance";

const ReferEarn = () => {
  const [open, setOpen] = useState(false);
  const [alreadyLogin, setAlreadyLogin] = useState(false);

  const handleOpenWalletDetails = () => {
    setOpen(true);
  };

  useEffect(() => {
    const value = localStorage.getItem("isAlreadyLogin");
    if (value && value == "true") {
      setAlreadyLogin(true);
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #123524 0%, #1f7a4d 45%, #1a6b42 100%)",
          borderBottom: `1px solid ${alpha("#fff", 0.12)}`,
          boxShadow: "0 12px 40px rgba(15, 23, 17, 0.15)",
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            mx: "auto",
            px: { xs: 2, sm: 3 },
            py: { xs: 2.5, sm: 3.5 },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#fff",
              fontWeight: 800,
              letterSpacing: "-0.03em",
              fontSize: { xs: "1.35rem", sm: "1.6rem" },
            }}
          >
            Refer & Earn
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: alpha("#fff", 0.88),
              mt: 0.75,
              maxWidth: "36rem",
              lineHeight: 1.5,
            }}
          >
            Share your code, grow your network, and earn SalonTym Coins &amp;
            cashback.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 2, sm: 3 },
          position: "relative",
        }}
      >
        <ReferEarnSlide />
        {alreadyLogin && (
          <IconButton
            aria-label="Open wallet details"
            sx={{
              position: "fixed",
              bottom: {
                xs: "calc(88px + env(safe-area-inset-bottom, 0px))",
                sm: "max(28px, env(safe-area-inset-bottom))",
              },
              right: { xs: 16, sm: 28 },
              background:
                "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
              padding: "14px",
              boxShadow: "0 12px 28px rgba(31, 122, 77, 0.35)",
              zIndex: 1020,
              "&:hover": {
                background:
                  "linear-gradient(135deg, #0f2a1c 0%, #1a6b42 100%)",
              },
            }}
            onClick={handleOpenWalletDetails}
          >
            <AccountBalanceWalletIcon
              fontSize="medium"
              sx={{ color: "#fff" }}
            />
          </IconButton>
        )}
      </Box>
      <WalletBalance
        openWalletDetails={open}
        handleCloseWalletDetails={() => setOpen(false)}
      />
    </>
  );
};

export default ReferEarn;
